export const rrjApiBase = "https://api.renrenjiang.cn";

export const SDKAppID = 1400817455;
